import { render } from "./AccountingHome.vue?vue&type=template&id=6a5df67f&scoped=true&ts=true&lang=pug"
import script from "./AccountingHome.vue?vue&type=script&lang=ts"
export * from "./AccountingHome.vue?vue&type=script&lang=ts"

import "./AccountingHome.vue?vue&type=style&index=0&id=6a5df67f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5df67f"]])

export default __exports__